import React from "react";
import { useTranslation } from "react-i18next";
import { SessionContext } from "../../types/sessionContext";
import { FormField } from "../../components/FormField";
import { getCurrentDemoConfig } from "../../config/demoSites";

interface Step1FormProps {
    currentStep: number;
    sessionContext: SessionContext;
    updateSessionContext: (newCtx: SessionContext) => void;
}

const Step1Form: React.FC<Step1FormProps> = ({ currentStep, sessionContext, updateSessionContext }) => {
    const { t } = useTranslation();
    const fields = sessionContext.layout.workflow.steps[currentStep].fields;
    const demoConfig = getCurrentDemoConfig();
    const stepConfig = demoConfig.steps.find(step => step.id === currentStep);

    const handleChange = (field: string, value: any) => {
        const updated = { ...sessionContext };
        updated.layout.workflow.steps[currentStep].fields[field] = value;
        updateSessionContext(updated);
    };

    return (
        <div>
            <h1 className="text-2xl font-semibold">{t(stepConfig?.titleKey || "base_demo.workflow.steps.step1form.title")}</h1>
            <p className="mb-4 text-gray-500">{t("base_demo.step1form.description")}</p>

            {/* Dynamically render fields based on configuration */}
            {stepConfig?.fields.map(fieldConfig => (
                <FormField
                    key={fieldConfig.fieldName}
                    field={fieldConfig}
                    value={fields[fieldConfig.fieldName] || ""}
                    onChange={value => handleChange(fieldConfig.fieldName, value)}
                    allFieldValues={fields}
                />
            ))}
        </div>
    );
};

export default Step1Form;
